import {
	OPTIMISTIC_SCAN_STATUS,
	getOptimisticScanStatus,
} from 'core/ElementViewBuilder/views/TransactionViewer/scanStatus';

const TRANSACTION_QUANTITY_FORMATTER = new Intl.NumberFormat('en-US', {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
});

const normalizeTransactionQuantityInput = value =>
	String(value ?? '')
		.replace(/,/g, '')
		.trim();

export const formatTransactionQuantityInput = (value, info = {}) => {
	if (value === undefined || value === null || value === '') return '';
	if (info.userTyping) return info.input;

	const numericValue = Number(normalizeTransactionQuantityInput(value));

	return Number.isFinite(numericValue)
		? TRANSACTION_QUANTITY_FORMATTER.format(numericValue)
		: String(value);
};

export const parseTransactionQuantityInput = value =>
	value === undefined || value === null
		? ''
		: normalizeTransactionQuantityInput(value).replace(/[^\d.-]/g, '');

export const getCurrentTransactionAmount = (
	rowData,
	{ usesAmountAsCurrentValue = false } = {},
) => Number((usesAmountAsCurrentValue ? rowData.amount : rowData.wtdi_amount) || 0);

export const getEditableTransactionLimitAmount = (
	rowData,
	{ usesAmountAsCurrentValue = false } = {},
) =>
	usesAmountAsCurrentValue
		? Number.MAX_SAFE_INTEGER
		: Number(rowData.amount || 0);

export const getEditableTransactionAmountPatch = (
	amount,
	{ usesAmountAsCurrentValue = false } = {},
) => (usesAmountAsCurrentValue ? { amount } : { wtdi_amount: amount });

const isSerializedTransactionItem = rowData =>
	rowData?.is_serialized === true ||
	rowData?.isSerialized === true ||
	['si', 'sí'].includes(
		String(rowData?.is_serialized ?? rowData?.isSerialized ?? '').toLowerCase(),
	);

export const getReadOnlyTransactionValue = ({
	rowData,
	isTransactionFrozen = false,
	usesAmountAsCurrentValue = false,
} = {}) => {
	if (!isSerializedTransactionItem(rowData))
		return getCurrentTransactionAmount(rowData, { usesAmountAsCurrentValue });

	const scanStatus = getOptimisticScanStatus(rowData);

	if (scanStatus === OPTIMISTIC_SCAN_STATUS.ERROR) return 'Error';
	if (scanStatus === OPTIMISTIC_SCAN_STATUS.PENDING) return 'Guardando';
	if (!rowData?.wtdi_id) return '-';
	return isTransactionFrozen ? 1 : 'Agregado';
};

export const getFormattedReadOnlyTransactionValue = ({
	rowData,
	isTransactionFrozen = false,
	isOriginTransaction = false,
	usesAmountAsCurrentValue = false,
} = {}) => {
	const value = getReadOnlyTransactionValue({
		rowData,
		isTransactionFrozen,
		usesAmountAsCurrentValue,
	});

	if (!isTransactionFrozen || !isOriginTransaction || typeof value !== 'number')
		return value;

	return usesAmountAsCurrentValue
		? formatTransactionQuantityInput(value)
		: value.toFixed(2);
};
